import { AccountService } from './shared/services/account.service';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { setDirectionScheme } from './shared/set-direction-scheme';
import { Title } from '@angular/platform-browser';
import cssVars from 'css-vars-ponyfill';
import { SocketService } from './shared/services/socket.service';
import { AuthService } from './shared/services/auth.service';
import * as Sentry from '@sentry/browser';
import { TokenStorageService } from './shared/services/helpers/token.service';
import { SocketData } from './shared/interfaces/socket-data.interface';
import { Account } from './shared/interfaces/profile.interface';
import { setModeTheme } from './shared/set-color-scheme';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  @HostListener('window:resize', ['$event'])
  onResize() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  @ViewChild('modeWrapper') modeWrapper: ElementRef;
  account: Account;
  constructor(
    public translate: TranslateService,
    public accountService: AccountService,
    private titleService: Title,
    private socketService: SocketService,
    private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private renderer: Renderer2) {
    // set language

    const account = this.accountService.getAccount();
    this.account = account;
    translate.addLangs(environment.languages);
    translate.setDefaultLang(environment.defaultLang);
    account && environment.languages.includes(account.language)
      ? translate.use(account.language)
      : translate.use('en');

    // set color scheme
    setDirectionScheme(this.translate.currentLang);

    // set vh (need for mobile devices)
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // set title and favicon
    this.setTitle(environment.title);
    this.changeIcon();

    // refresh token
    const token = this.tokenStorage.getToken();
    if (token) {
      this.authService.startRefreshTokenTimer();
    }
  }

  ngOnInit() {
    // Sentry.init({
    //   dsn: 'https://b0b7adbe5a68fb04eaed6e20f17bd160@sentry.onix.team/213',
    // });

    cssVars();
    this.socketService.getEventData().subscribe((res: SocketData) => {
      if (res.event === this.socketService.EVENTS.logoutUser) {
        this.authService.getProfile().subscribe();
      }
    });
  }

  ngAfterViewInit() {
    // set mode
    if (this.account) {
      if (this.account.uses_dark_mode) {
        this.renderer.addClass(document.body, 'dark-mode');
        this.renderer.setAttribute(document.body, 'id', 'mode-wrapper');
      } else {
        this.renderer.removeAttribute(document.body, 'id');
        this.renderer.removeClass(document.body, 'dark-mode');
      }
      setModeTheme(this.account.role, this.account.uses_dark_mode);
    }
  }

  setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  changeIcon() {
    this.favIcon.href = environment.favicon;
  }
  ngOnDestroy() {
    Sentry.init({
      enabled: false,
    });
    Sentry.close();
  }
}
